<ion-menu side="end" type="push" contentId="main" swipeGesture="false">
  <ion-header>
    <ion-toolbar>
      <ion-icon name="close" class="close-icon" slot="end" (click)="closeSideMenu()"> </ion-icon>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <ion-list>
      <div *ngFor="let item of sideMenu">
        <ion-item lines="none" *ngIf="!item.hide">
          <ion-button expand="full" [disabled]="item.disabled" (click)="handleNavigation(item.title)">
            {{ item.title }}
          </ion-button>
        </ion-item>
      </div>
    </ion-list>
  </ion-content>
</ion-menu>
